import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Bell } from "lucide-react";
import NotificationPrefs from "@/components/NotificationPrefs";

/**
 * Dedicated notifications window. Moved out of the Garage per user request —
 * notifications belong here, not on the profile/garage page.
 */
export default function Notifications() {
    const navigate = useNavigate();
    return (
        <div className="min-h-screen bg-onyx-900 text-white">
            <div
                className="sticky top-0 z-30"
                style={{
                    background: "rgba(6,6,6,0.92)",
                    borderBottom: "1px solid #262626",
                    backdropFilter: "blur(18px)",
                }}
            >
                <div className="max-w-3xl mx-auto px-4 py-3 flex items-center gap-2">
                    <button
                        onClick={() => navigate(-1)}
                        className="btn-ghost px-2.5 py-2"
                        style={{ borderRadius: 4 }}
                        data-testid="notifications-back"
                    >
                        <ArrowLeft className="w-4 h-4" />
                    </button>
                    <div className="headline text-lg flex items-center gap-2">
                        <Bell className="w-5 h-5 text-hellcat" /> Notifications
                    </div>
                </div>
            </div>
            <NotificationPrefs />
        </div>
    );
}
